import { createSlice } from "@reduxjs/toolkit";
import { donationCampCategory } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const campCategorySlice = createSlice({
  name: "campCategory",
  initialState: data,
  reducers: {
    campCategorySlice(state) {
      state.isLoading = false;
    },
    campCategorySliceSuccess(state, action) {
      state.isLoading = true;
      state.data = action.payload;
      state.message = null;
    },
    campCategorySliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
    },
    campCategorySliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const campCategoryHandler = () => async (dispatch: any) => {
  try {
    dispatch(campCategoryAction.campCategorySlice());
    const response: any = await donationCampCategory();
    dispatch(campCategoryAction.campCategorySliceSuccess(response));
  } catch (e: any) {
    dispatch(campCategoryAction.campCategorySliceFailure(e?.response?.data?.message));
    dispatch(campCategoryAction.campCategorySliceReset());
  }
};
export default campCategorySlice.reducer;
export const campCategoryAction = campCategorySlice.actions;
